import type { BizStatusCode } from '@/config/biz-status'
import { zhCNMessages } from '@/locale/zh-CN'
import { enUSMessages } from '@/locale/en-US'

export type AppLocale = 'zh-CN' | 'en-US'

const LOCALE_KEY = 'app_locale'

const catalogs: Record<AppLocale, Record<BizStatusCode, string>> = {
  'zh-CN': zhCNMessages,
  'en-US': enUSMessages,
}

export function getLocale(): AppLocale {
  try {
    const saved = uni.getStorageSync(LOCALE_KEY) as AppLocale
    if (saved && catalogs[saved]) return saved
  } catch {
    /* ignore */
  }
  return 'zh-CN'
}

export function setLocale(locale: AppLocale): void {
  uni.setStorageSync(LOCALE_KEY, locale)
}

/** 根据后端 status 码取本地化文案 */
export function tBizStatus(status: string, fallback?: string): string {
  const locale = getLocale()
  const catalog = catalogs[locale]
  const text = catalog[status as BizStatusCode]
  return text ?? fallback ?? status
}
